/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import { ApplicationState } from 'store';
import { getFilterOptions, searchFilters } from 'store/modules/market_store/actions';
import { MarketState } from 'store/modules/market_store/types';
import Loader from 'components/atoms/loader';
import { CitiesTypes, ModalitiesTypes, StatesTypes } from 'store/modules/online_search_store/types';
import { Modalities } from 'services/modalities';
import { getCitiesByStates } from 'services/actions/cities_actions';
import { esferasOption, esferasOptions } from 'services/esferas_contracts';
import { States } from 'services/states';
import { ProfileState } from 'store/modules/profile_store/types';
import companyId from 'services/company_id';
import { PanelState } from 'store/modules/panel_store/types';
import { Container } from './styles';

interface MarketSearchProps {
  setSearchBarOpened: React.Dispatch<React.SetStateAction<boolean>>;
  searchBarOpened: boolean;
  setSelectedPeriod: React.Dispatch<React.SetStateAction<number | object[]>>;
  exactSearch: boolean;
  serExactSearch: React.Dispatch<React.SetStateAction<boolean>>;
  selectedPeriod: any;
  advanced_search: boolean;
  serAdvancedSearch: React.Dispatch<React.SetStateAction<boolean>>;
  setParams: React.Dispatch<any>;
}

const MarketSearch = (props: MarketSearchProps) => {
  const dispatch = useDispatch();
  const {
    setSearchBarOpened,
    searchBarOpened,
    setSelectedPeriod,
    exactSearch,
    serExactSearch,
    selectedPeriod,
    advanced_search,
    serAdvancedSearch,
    setParams,
  } = props;

  const { get_filters, request } = useSelector<ApplicationState, MarketState>(
    (state) => state.session.market,
  );

  const [statesList, setStatesList] = useState<Array<StatesTypes>>([]);
  const [citiesList, setCitiesList] = useState<Array<CitiesTypes>>([]);
  const [modalidade, setModalidade] = useState<Array<ModalitiesTypes>>([]);
  const [modalitiesList, setModalitiesList] = useState<Array<ModalitiesTypes>>([]);
  const [cities, setCities] = useState<Array<CitiesTypes>>([]);
  const [selectedEsfera, setSelectedEsfera] = useState<Array<esferasOption>>([]);
  const [term, setTerm] = useState<string>('');
  const [buyerInput, setBuyerInput] = useState<string>('');
  const [providerInput, setProviderInput] = useState<string>('');
  const [itemInput, setItemInput] = useState<string>('');
  const [minValue, setMinValue] = useState<string>('');
  const [maxValue, setMaxValue] = useState<string>('');
  const [followupValue, setFollowupValue] = useState<string>('');
  const [typeValue, setTypeValue] = useState<Array<object> | number>(1);
  const [selectedFilter, setSelectedFilter] = useState<Array<any | null>>([]);
  const esfera = selectedEsfera?.map((selectedEsfera) => selectedEsfera.value);
  const Getcities = cities?.map((cities) => cities.value);
  const state = statesList?.map((statesList) => statesList.value);
  const modalidadeSelecionada = modalidade?.map((modalidade) => modalidade.value);
  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);
  const { panel } = useSelector<ApplicationState, PanelState>((state) => state.session.panel);

  const typeValueOptions = [
    { value: 1, label: 'Valor Total' },
    { value: 2, label: 'Valor Unitário' },
  ];

  const intervalOptions = [
    { value: 3, label: 'Últimos 3 meses' },
    { value: 6, label: 'Últimos 6 meses' },
    { value: 9, label: 'Últimos 9 meses' },
    { value: 12, label: 'Últimos 12 meses' },
    { value: 24, label: 'Últimos 24 meses' },
  ];

  useEffect(() => {
    if (selectedFilter?.length > 0 && !advanced_search) {
      setModalitiesList(
        Modalities?.map((modalidade) => ({
          label: `${modalidade.sigla} - ${modalidade.nome}`,
          value: modalidade.id,
        })),
      );
    }
  }, [advanced_search, selectedFilter, Modalities]);

  useEffect(() => {
    (async () => {
      const statesIds = statesList?.map((state) => state.value);
      if (statesIds?.length > 0) {
        const citiesResponse = await getCitiesByStates(statesIds);
        setCitiesList(
          citiesResponse?.map((city: any) => ({
            label: `${city.name_sub} - ${city.acronym}`,
            value: city.id,
          })),
        );
      } else {
        setCitiesList([]);
      }
    })();
  }, [statesList]);

  useEffect(() => {
    if (request.get_filters?.loaded) {
      setSelectedFilter(
        get_filters?.map((val) => ({
          value: val.filter.id,
          label: val.filter.description,
        })),
      );
    }
  }, [request.get_filters?.loaded]);

  useEffect(() => {
    if (selectedFilter[0]?.value > 0) {
      dispatch(getFilterOptions(Number(selectedFilter[0]?.value), companyId(profile)));
    }
  }, [selectedFilter]);

  const handleClick = async () => {
    const params = {
      filter_id: selectedFilter[0]?.value,
      interval: selectedPeriod,
      exact_search: exactSearch,
      advanced_search,
      states: state,
      cities: Getcities,
      modalities: modalidadeSelecionada,
      public_body_types: esfera,
      buyer_input: buyerInput,
      term,
      provider_input: providerInput,
      item_input: itemInput,
      min_value: minValue,
      max_value: maxValue,
      type_value: typeValue,
      followup_input: followupValue,
    };
    setParams(params);
    dispatch(searchFilters(params));
  };

  return (
    <Container>
      <div className="row">
        <div
          className={`col-11 mx-auto col-lg-3 col-md-12 pr-2 filter-bar shadow ${
            searchBarOpened ? '' : 'hide-bar'
          } ${
            profile.in_sample || panel?.registration_type_validation === 1 ? 'hasTopBanner' : ''
          }`}
        >
          <button
            type="button"
            onClick={() => setSearchBarOpened(!searchBarOpened)}
            className="btn btn-sm btn-link position-absolute btn-hide-search d-xxl-none"
          >
            <i className="material-icons p-1">search</i>
          </button>
          <div className={`filter-form pr-2 ${advanced_search && 'scroll-lateral'}`}>
            <div className="row d-print-none">
              <div className="col-md-12">
                <div className="row mt-4">
                  <div className="col-md-6">Pesquisa</div>
                  <div className="col-md-6">
                    <button
                      type="button"
                      className="btn btn-sm btn-link float-right"
                      onClick={() => serAdvancedSearch(!advanced_search)}
                    >
                      {advanced_search ? 'Busca simples' : 'Busca avançada'}
                    </button>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <input
                      type="text"
                      className="form-control"
                      id="keyword"
                      placeholder="Filtrar por palavra-chave..."
                      value={term}
                      onChange={(e) => setTerm(e.target.value)}
                    />
                  </div>
                </div>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="exact_search"
                    checked={exactSearch}
                    onChange={(e) => serExactSearch(e.target.checked)}
                  />
                  <label className="form-check-label mt-1" htmlFor="exact_search">
                    Busca Exata
                  </label>
                </div>
              </div>
            </div>
            {request?.get_filters?.loading ? (
              <Loader />
            ) : (
              <div>
                <div className="row mb-3 my-4">
                  <div className="col-md-12">
                    <label className="m-0">Período de análise</label>
                    <Select
                      name="period"
                      options={intervalOptions}
                      placeholder="Selecione o período"
                      defaultValue={intervalOptions[3]}
                      classNamePrefix="select"
                      className="basic-multi-select"
                      onChange={(selected) => {
                        setSelectedPeriod(selected?.value as any);
                      }}
                    />
                  </div>
                </div>
                <div className="row mb-3 my-4">
                  <div className="col-md-12">
                    <label className="m-0">Seleção</label>
                    <Select
                      className="filter-input"
                      defaultValue={selectedFilter[0]}
                      value={selectedFilter[0]}
                      options={get_filters?.map((filter) => {
                        return {
                          label: filter.filter.description,
                          value: filter.filter.id,
                        };
                      })}
                      onChange={(event) => setSelectedFilter([event])}
                    />
                  </div>
                </div>
              </div>
            )}

            {advanced_search && (
              <div>
                <hr />
                <div className="row d-print-none">
                  <div className="col-md-12">
                    <div className="row mt-4">
                      <div className="col-md-6">Estados</div>
                      <div className="col-md-6">
                        <button
                          type="button"
                          className="btn btn-sm btn-link float-right"
                          onClick={() => setStatesList(States)}
                        >
                          Todos os Estados
                        </button>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12">
                        <Select
                          name="StateSearch"
                          isMulti
                          value={statesList || ''}
                          closeMenuOnSelect={false}
                          onChange={(event) => setStatesList([...event])}
                          options={States}
                          placeholder="Selecione os Estados"
                          className="basic-multi-select"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-md-12">
                    <label htmlFor="stateSearch" className="m-0">
                      Cidades
                    </label>
                    <Select
                      name="CitySearch"
                      isMulti
                      closeMenuOnSelect={false}
                      value={cities || ''}
                      onChange={(event) => setCities([...event])}
                      options={citiesList}
                      noOptionsMessage={() => 'Selecione um estado'}
                      placeholder="Selecione as Cidades"
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <div className="row mt-4">
                      <div className="col-md-6">Modalidades</div>
                      <div className="col-md-6">
                        <button
                          type="button"
                          className="btn btn-sm btn-link float-right"
                          onClick={() => setModalidade(modalitiesList)}
                        >
                          Todas as Modalidades
                        </button>
                      </div>
                    </div>
                    <Select
                      name="modalitiesSearch"
                      isMulti
                      value={modalidade || ''}
                      closeMenuOnSelect={false}
                      onChange={(event) => setModalidade([...event])}
                      options={modalitiesList}
                      placeholder="Selecione as Modalidades"
                      className="basic-multi-select"
                    />
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-md-12">
                    <label className="m-0">Esfera</label>
                    <Select
                      isMulti
                      name="esferas"
                      options={esferasOptions}
                      placeholder="Selecione as Esferas"
                      classNamePrefix="select"
                      className="basic-multi-select"
                      onChange={(event) => setSelectedEsfera([...event])}
                    />
                  </div>
                </div>
                <hr />
                <div className="row">
                  <div className="col-md-12">
                    <label>Órgão público</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Nome ou código do órgão"
                      onChange={(event) => {
                        setBuyerInput(event.target.value);
                      }}
                    />
                  </div>
                </div>
                <hr />
                <div className="row">
                  <div className="col-md-12">
                    <label>Concorrente</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Nome ou CNPJ da empresa"
                      onChange={(event) => {
                        setProviderInput(event.target.value);
                      }}
                    />
                  </div>
                </div>
                <hr />
                <div className="row">
                  <div className="col-md-12">
                    <label>Item</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Pesquise na descrição, marca e fabricante"
                      onChange={(event) => {
                        setItemInput(event.target.value);
                      }}
                    />
                  </div>
                </div>
                <div className="row px-3 mt-3 mb-2">
                  <div className="mb-1 w-100" style={{ fontSize: '13.5px' }}>
                    Valor do item
                  </div>
                  <div className="col-md-4 pl-md-0 px-0 mb-2 mb-md-0">
                    <input
                      type="number"
                      step="0.01"
                      className="form-control"
                      placeholder="Mínimo"
                      onChange={(event) => {
                        setMinValue(event.target.value);
                      }}
                    />
                  </div>
                  <div className="col-md-4 px-md-2 px-0 mb-2 mb-md-0">
                    <input
                      type="number"
                      step="0.01"
                      className="form-control"
                      placeholder="Máximo"
                      onChange={(event) => {
                        setMaxValue(event.target.value);
                      }}
                    />
                  </div>
                  <div className="col-md-4 px-md-0 px-0 mb-2 mb-md-0">
                    <Select
                      name="typeValue"
                      options={typeValueOptions}
                      defaultValue={typeValueOptions[0]}
                      classNamePrefix="select"
                      onChange={(event) => {
                        setTypeValue(event?.value as any);
                      }}
                    />
                  </div>
                </div>
                <hr />
                <div className="row">
                  <div className="col-md-12">
                    <label>Acompanhamento</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Pesquise na síntese do acompanhamento"
                      onChange={(event) => {
                        setFollowupValue(event.target.value);
                      }}
                    />
                  </div>
                </div>
                <hr />
              </div>
            )}
            <div className="col-12 px-0 pt-2 d-print-none mt-5">
              <button type="button" className="btn btn-primary w-100" onClick={() => handleClick()}>
                Filtrar dados
              </button>
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default MarketSearch;
